import React from 'react';
import './TableBody.css';

const TableBody = ({ items, renderItem }) => (
  <div className="lutable__row-group">{items.map(renderItem)}</div>
);
export default TableBody;
